import factory from './icon';
import Measure from './glyphs/icon-measure.svg';

export default factory(Measure);
